import { render } from "./LatestItems.vue?vue&type=template&id=1339e7fe"
import script from "./LatestItems.vue?vue&type=script&lang=js"
export * from "./LatestItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__